<div class="action-page">
  <div class="av2-wrap">

    <div class="av2-card" *ngIf="state === 'loading'">
      <p class="eyebrow">Alert settings</p>
      <div class="sk-line"></div>
      <div class="sk-line short"></div>
    </div>

    <div class="av2-card" *ngIf="state === 'confirm' || state === 'working'">
      <p class="eyebrow">Alert settings</p>
      <h1 class="stmt">One click, and it's quiet.</h1>
      <p class="desc">{{ info?.description }}</p>
      <div class="acts">
        <button class="av2-btn av2-btn--green" [disabled]="state === 'working'" (click)="confirm()">Confirm</button>
        <a class="av2-btn av2-btn--ghost" routerLink="/account/followed">Manage alerts instead</a>
      </div>
      <p class="note">Nothing is deleted. Your plates and searches stay in your account.</p>
    </div>

    <div class="av2-card" *ngIf="state === 'done'">
      <p class="eyebrow">Alert settings</p>
      <h1 class="stmt">Done.</h1>
      <p class="desc">{{ info?.description }}</p>
      <div class="acts">
        <a class="av2-btn av2-btn--ghost" routerLink="/account/followed">Manage your alerts</a>
      </div>
    </div>

    <div class="av2-card" *ngIf="state === 'invalid'">
      <p class="eyebrow">Alert settings</p>
      <h1 class="stmt">That link didn't work.</h1>
      <p class="desc">{{ invalidMessage }}</p>
      <div class="acts">
        <a class="av2-btn av2-btn--ghost" routerLink="/account/followed">Manage your alerts</a>
      </div>
    </div>

  </div>
</div>
